import { useAuth } from 'contexts/authUser/store';

export const useGetContactFormDefaultValues = () => {
  const { user } = useAuth();
  return {
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    company: '',
    email: user?.email || '',
    message: ''
  };
};
